export default __webpack_public_path__ + "static/media/cex-text-logo.694bf078.png";